import { d as defineCustomElement } from '../chunks/vidstack-KTx0QncX.js';
import { i as MediaLayoutElement, e as MediaControlsElement, f as MediaControlsGroupElement, b as MediaPosterElement, l as MediaCaptionButtonElement, m as MediaFullscreenButtonElement, k as MediaMuteButtonElement, n as MediaPIPButtonElement, j as MediaPlayButtonElement, o as MediaSeekButtonElement, p as MediaToggleButtonElement, G as MediaSliderElement, N as MediaVolumeSliderElement, K as MediaTimeSliderElement, O as MediaSliderChaptersElement, L as MediaSliderPreviewElement, I as MediaSliderValueElement, H as MediaSliderThumbnailElement, J as MediaSliderVideoElement, w as MediaMenuElement, x as MediaMenuButtonElement, y as MediaMenuPortalElement, A as MediaMenuItemsElement, z as MediaMenuItemElement, u as MediaAudioRadioGroupElement, v as MediaCaptionsRadioGroupElement, C as MediaSpeedRadioGroupElement, D as MediaQualityRadioGroupElement, B as MediaChaptersRadioGroupElement, F as MediaRadioGroupElement, E as MediaRadioElement, r as MediaTooltipElement, s as MediaTooltipTriggerElement, t as MediaTooltipContentElement, a as MediaGestureElement, c as MediaThumbnailElement, M as MediaCaptionsElement, q as MediaLiveButtonElement, d as MediaTimeElement, g as MediaChapterTitleElement, h as MediaSpinnerElement } from '../chunks/vidstack-kXv5I-Lo.js';
import '../chunks/vidstack-2JOJlpjE.js';
import '../chunks/vidstack-DTSGQ87h.js';
import '../chunks/vidstack-S5-ZnP-2.js';
import '../chunks/vidstack-Yx-0ZQdX.js';
import '../chunks/vidstack-PDESAD8i.js';
import '../chunks/vidstack-wDXs-Qf-.js';
import '../chunks/vidstack-ZF6S2MdD.js';
import '../chunks/vidstack-OD2a9fal.js';
import '../chunks/vidstack-9YwbvY-y.js';
import '../chunks/vidstack-0rFKBzFo.js';

defineCustomElement(MediaLayoutElement);
defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaToggleButtonElement);
defineCustomElement(MediaSliderElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderChaptersElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderVideoElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuPortalElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaChaptersRadioGroupElement);
defineCustomElement(MediaRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaTooltipContentElement);
defineCustomElement(MediaGestureElement);
defineCustomElement(MediaThumbnailElement);
defineCustomElement(MediaCaptionsElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaChapterTitleElement);
defineCustomElement(MediaSpinnerElement);
